<template>
    <el-dialog :visible="visible" width="500px" :before-close="handleClose" :show-close="false" class="account-transfer-dialog" center>
        <div class="dialog-title">主管身份轉移</div>
        <div class="description">此帳號為主管帳號，停用時需要將直屬員工轉移給其他帳號。</div>
        <div class="account-list">
            <el-tag class="staff-item" v-for="item in subordinateList" :key="item.sno">{{ item.nam }}</el-tag>
        </div>
        <div class="spacer-title">將轉移給</div>
        <div class="target-selects">
            <el-select v-model="transfer.dept" placeholder="選擇部門" no-data-text="無資料" @change="selectTransfer">
                <el-option v-for="item in departmentList" :key="item.sno" :label="item.deP_NAM" :value="item.sno" />
            </el-select>
            <el-select v-model="transfer.boss" placeholder="選擇員工" no-data-text="無資料">
                <el-option v-for="item in transferMemberList" :key="item.sno" :label="item.nam" :value="item.sno" />
            </el-select>
        </div>
        <span slot="footer">
            <el-button type="" @click="handleCancel">取消停用</el-button>
            <el-button v-if="!isQR()" type="primary" @click="handleClose">確定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        subordinateList: {
            type: Array,
            default: null,
        },
        selectMember: {
            type: Object,
            default: null,
        },
        currentSno: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transfer: {
                dept: '',
                boss: '',
            },
            departmentList: [],
            transferMemberList: [],
        };
    },
    created() {
        this.$api({
            url: '/StaffManagementPage/GetDepartmentOptions',
            method: 'GET',
        })
            // 取得成功
            .then((resp) => {
                // 更新資料
                this.departmentList = resp.data.options;
            });

        if (this.selectMember) {
            this.transfer = this.selectMember;
        }
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handleClose() {
            const transferer = this.transferMemberList.find((x) => x.sno === this.transfer.boss);

            if (transferer) {
                this.transfer.name = transferer.nam;
                this.$emit('close', this.transfer);
            } else {
                this.$emit('close');
            }
        },
        selectTransfer(value) {
            this.transfer.boss = '';
            this.$api({
                url: `/StaffManagementPage/GetManagerOptions?sno=${value}`,
                method: 'get',
            }).then((resp) => {
                this.transferMemberList = resp.data.options.filter((x) => x.sno != 1 && x.sno != 2 && x.sno != this.currentSno);
            });
        },
    },
};
</script>
<style lang="scss">
.account-transfer-dialog {
    .dialog-title {
        font-size: 16pt;
        font-weight: bold;
        text-align: center;
        padding: 20px 0;
    }

    .description {
        text-align: center;
        margin-bottom: 20px;
    }

    .spacer-title {
        text-align: center;
        font-weight: bold;
        display: block;
        margin-bottom: 15px;
    }

    .account-list {
        text-align: center;
        margin-bottom: 25px;
    }

    .target-selects {
        text-align: center;

        .el-select:first-child {
            margin-right: 12px;
        }
    }

    .staff-item {
        margin-left: 6px;

        &:first-child {
            margin-left: 0;
        }
    }
}
</style>
